import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NumberOnlyDirective } from './number-only.directive';
import { HomeComponent } from './home/home.component';
import { HttpErrorInterceptor } from './shared/interceptor/error.interceptor';
import { BehaviourSubjectService } from './shared/services/behaviour-subject.service';
// import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from "ngx-spinner";
import { BannerComponent } from './home/banner/banner.component';
import { BrowsByApplicationComponent } from './home/brows-by-application/brows-by-application.component';
import { SharedModule } from './shared/shared.module';
import { FindDealersComponent } from './home/find-dealers/find-dealers.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { BrandsYouCanTrustComponent } from './home/brands-you-can-trust/brands-you-can-trust.component';
import { ExploreVehicleRangeComponent } from './home/explore-vehicle-range/explore-vehicle-range.component';
import { PopularVehicleComponent } from './home/popular-vehicle/popular-vehicle.component';
import { TataMitraComponent } from './home/tata-mitra/tata-mitra.component';
import { CustomerStoriesComponent } from './home/customer-stories/customer-stories.component';
import { DealerStoriesComponent } from './home/dealer-stories/dealer-stories.component';

import { OurOtherServicesComponent } from './home/our-other-services/our-other-services.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FooterComponent } from './footer/footer.component';
import { isPlatformBrowser } from '@angular/common';
import { RootService } from './shared/services/root.service';
import { CookieService } from './shared/services/cookie.service';
import { MyHttpInterceptor } from './shared/interceptor/http.interceptor';
import { AgmCoreModule } from '@agm/core';
import { SafePipeModule } from 'safe-pipe';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { CommonService } from './shared/services/common.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { NgxSkeletonModule } from 'ngx-skeleton';
import { TataMitraBlogsComponent } from './tata-mitra/tata-mitra-blogs/tata-mitra-blogs.component';
import { TataMitraBlogDetailsComponent } from './tata-mitra/tata-mitra-blog-details/tata-mitra-blog-details.component';
// import { SitemapComponent } from './sitemap/sitemap.component';
import { SanitizeurlPipe } from './shared/safeurl.pipe';
import { ReplacePipe } from './shared/replace.pipe';
// import { BrandPageComponent } from './brand-page/brand-page.component';
// import { PopularComparisonComponent } from './popular-comparison/popular-comparison.component';
// import { ExplorePageComponent } from './explore-page/explore-page.component';
import { NgxStarsModule } from 'ngx-stars';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AuthGuard } from './shared/services/auth/auth.guard';
import { NgxPaginationModule } from 'ngx-pagination';
import { FindDealerComponent } from './find-dealer/find-dealer.component';
import { StoreModule } from "@ngrx/store";
import { reducers } from './configurator-app/conf-store/reducer/index';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ConfiguratorAppModule } from './configurator-app/configurator-app.module'
import { APP_BASE_HREF } from '@angular/common';
// import { AmcPackagesComponent } from './amc-packages/amc-packages.component';
import { environment } from '../environments/environment';
// import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { OfferDetailsComponent } from './offer-details/offer-details.component';
// import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { NgxsModule } from '@ngxs/store';
import { AppState } from './fni-modules/core/store/app.state';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { BrandOffersComponent } from './brand-offers/brand-offers.component';
import { NgxLiteYoutubeModule } from 'ngx-lite-video';
// import { XmlComponentComponent } from './xml-component/xml-component.component';
import { ExploreProductBuildVehicleComponent } from './explore-product-build-vehicle/explore-product-build-vehicle.component';
import { OfflineDirective } from './shared/conectivity.directive';
import { CountUpDirective } from './shared/count-up.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { BrandpageComponent } from './brandpage/brandpage.component';
import { CategoryComponent } from './category/category.component';
import { BrandCardComponent } from './brandCard/brand-card/brand-card.component';
import { CustomerTestimonialComponent } from './customer-testimonial/customer-testimonial.component';
import { ConfSharedModule } from './configurator-app/Conf-Shared/conf-shared.module';
import { VasDashboardTncComponent } from './vas-dashboard-tnc/vas-dashboard-tnc.component';
import { QuotationComponent } from './quotation/quotation.component';
// import { EmiCalculatorComponent } from './product/emi-calculator/emi-calculator.component';
// import { ProductCompareComponent } from './product/product-compare/product-compare.component';
// import { ProductDetailComponent } from './product/product-detail/product-detail.component';
// import { ProductRatingComponent } from './product/product-rating/product-rating.component';
// import { ProductSimilarVehicleComponent } from './product/product-similar-vehicle/product-similar-vehicle.component';
// import { VehicleSpecificationComponent } from './product/vehicle-specification/vehicle-specification.component';
import { FinanceOffersComponent } from './finance-offers/finance-offers.component';

export function init_app(storageService: RootService) {
  if (isPlatformBrowser(storageService.getBrowserID())) {
    const APP_VERSION = environment.version;
    if (typeof localStorage['APP_VERSION'] === 'undefined' || localStorage['APP_VERSION'] === null) {
      // localStorage.clear();
      localStorage.setItem('APP_VERSION', APP_VERSION);
    }
    if (localStorage['APP_VERSION'] != APP_VERSION) {
      // localStorage.clear();
      storageService.logout();
      localStorage.setItem('APP_VERSION', APP_VERSION);
    }
  }
  let refreshToken = storageService.getRefreshToken();

  let userData = storageService.getUserId();
  if (refreshToken && userData) {

    return () => storageService.refreshToken2();
  } else {

    return () => storageService.getFreeSearchToken();
  }
}

// const ngWizardConfig: NgWizardConfig = {
//   theme: THEME.default
// };

@NgModule({
  declarations: [
    OfflineDirective,CountUpDirective,NumberOnlyDirective,SanitizeurlPipe, ReplacePipe,
    AppComponent, ExploreVehicleRangeComponent,ExploreProductBuildVehicleComponent,HomeComponent,
    BannerComponent,BrowsByApplicationComponent, BrandsYouCanTrustComponent,PopularVehicleComponent,
    CustomerStoriesComponent, DealerStoriesComponent,OurOtherServicesComponent,
    TataMitraComponent, TataMitraBlogsComponent, TataMitraBlogDetailsComponent,
    FindDealersComponent,
    FooterComponent,
    FindDealerComponent,
     OfferDetailsComponent,
     BrandOffersComponent,BrandpageComponent,CategoryComponent,BrandCardComponent,
     CustomerTestimonialComponent, VasDashboardTncComponent,QuotationComponent,
    //  ProductDetailComponent,
    // VehicleSpecificationComponent,
    // EmiCalculatorComponent,
    // ProductCompareComponent,
    // ProductRatingComponent,
    // ProductSimilarVehicleComponent,
    FinanceOffersComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    HttpClientModule,
    NgxSkeletonModule,
    ConfiguratorAppModule,
    NgxLiteYoutubeModule,
    StoreDevtoolsModule.instrument({maxAge: 25}),
    BrowserAnimationsModule,
    StoreModule.forRoot(reducers),
    ToastrModule.forRoot({toastClass: 'custom-toster ngx-toastr'}),
    SlickCarouselModule,
    NgxSpinnerModule.forRoot(),
    SharedModule,
    NgSelectModule,
    CommonModule,
    CarouselModule,
    MatDialogModule,
    SafePipeModule,
    NgbModule,
    ConfSharedModule,
    NgxStarsModule,
    AgmCoreModule.forRoot({ apiKey: "AIzaSyBcGudZMXCMmd9uHo-WXYrBGplcWvCNOZU" }),
    NgxPaginationModule,FormsModule, ReactiveFormsModule,
    NgxSliderModule,
    NgxsModule.forRoot([AppState], { developmentMode: true }),
    NgxsReduxDevtoolsPluginModule.forRoot(),
  ],
  exports: [
    // BrtCalculatorAdvanceComponent,AdvanceSearchComponent,
  ],
  providers: [
    RootService, AuthGuard, { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_INTERCEPTORS, useClass: MyHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [
        RootService, CookieService, CommonService],
      multi: true
    },
    BehaviourSubjectService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA],
})
export class AppModule { }
